import React from 'react';
import Spinner from '../../components/ui/Spinner';
import { withAuthToken } from '../../utils/fileUrl';

export default function EvidencesTab({
  drawerReport,
  isReportLocked,
  drawerEvidences,
  uploadType, setUploadType,
  uploadFiles, setUploadFiles,
  uploadSaving,
  fileRef,
  onUpload,
  onDeleteEvidence,
}) {
  if (!drawerReport) {
    return <p className="info-box">Guarda el informe primero para adjuntar evidencias.</p>;
  }

  return (
    <>
      {!isReportLocked && (
        <form onSubmit={onUpload} className="upload-form">
          <div className="upload-type-row">
            <label className={`type-pill${uploadType === 'photo' ? ' active' : ''}`}>
              <input type="radio" name="uploadType" value="photo"
                checked={uploadType === 'photo'}
                onChange={() => setUploadType('photo')} />
              📷 Fotografías
            </label>
            <label className={`type-pill${uploadType === 'document' ? ' active' : ''}`}>
              <input type="radio" name="uploadType" value="document"
                checked={uploadType === 'document'}
                onChange={() => setUploadType('document')} />
              📄 Documentos
            </label>
          </div>
          <input
            ref={fileRef}
            type="file"
            multiple
            accept={uploadType === 'photo' ? '.jpg,.jpeg,.png' : '.pdf,.docx'}
            onChange={e => setUploadFiles(e.target.files)}
          />
          <button type="submit" className="btn-primary" disabled={uploadSaving}>
            {uploadSaving ? <Spinner /> : 'Adjuntar'}
          </button>
          <p className="hint">Máximo 16 archivos y 10 MB por archivo.</p>
        </form>
      )}

      <ul className="evidence-list">
        {drawerEvidences.length === 0 && <li className="empty-item">Sin evidencias adjuntas.</li>}
        {drawerEvidences.map(ev => (
          <li key={ev.id} className="evidence-item">
            <span className="ev-icon">{ev.fileType === 'photo' ? '📷' : '📄'}</span>
            <div className="ev-info">
              <span className="ev-name">{ev.originalName}</span>
              <span className="ev-size">{(ev.fileSizeBytes / 1024 / 1024).toFixed(2)} MB</span>
              {ev.fileUrl && (
                <a
                  href={withAuthToken(ev.fileUrl)}
                  target="_blank"
                  rel="noreferrer"
                  className="ev-open-link"
                >
                  {ev.fileType === 'photo' ? 'Ver imagen' : 'Abrir documento'}
                </a>
              )}
            </div>
            {!isReportLocked && (
              <button className="btn-del" onClick={() => onDeleteEvidence(ev.id)}>🗑</button>
            )}
          </li>
        ))}
      </ul>
    </>
  );
}
